<!-- <div *ngIf="showSplash && browser != 'android' && isRegionSupported"> -->
<div *ngIf="showSplash && browser != 'android'">
    <app-splash-screen></app-splash-screen>
</div>
<!-- Button prompt for mweb -->
<app-app-install-button></app-app-install-button>
<!-- end of button -->

<!-- <div style="display: none" *ngIf="isServer && !showSplash && isRegionSupported"> -->
<div style="display: none" *ngIf="isServer && !showSplash">
    <app-header></app-header> 
    <router-outlet></router-outlet>
    <!-- <ngx-spinner template="<video autoplay muted loop src='./assets/tarangplus/danaglPlay_loader-02.mp4' playsinline style='width:100px;height:100px'></video>" ></ngx-spinner> -->
    <ngx-spinner class="loader-1"  template="<img src='./assets/tarangplus/tarang-loader-logo.gif' style='width:100px;height:100px'/>" ></ngx-spinner>
    <app-footer *ngIf="browser !== 'android'"></app-footer>
</div>

<div  *ngIf="isBrowser && !showSplash" style="height: 100%;">
    <div *ngIf="isRegionSupported">
    <!-- <div> -->
        <app-header *ngIf="showLayout"></app-header> 
        <router-outlet></router-outlet>
        <ngx-spinner *ngIf="showLayout"  template="<img src='./assets/tarangplus/tarang-loader-logo.gif' style='width:100px;height:100px'/>" ></ngx-spinner>
        <app-footer *ngIf="showLayout"></app-footer>
    </div>
    <app-not-supported *ngIf="!isRegionSupported"></app-not-supported>
</div>